module.exports = __webpack_public_path__ + "img/icon_vox-series-1.fd68e02.png";